const Footer = () => {
  return (
    <footer className="Footer">
      <a
        id="footer"
        href="https://tusharreddy.com"
        target="_blank"
        rel="noopener noreferrer"
      >
        $Source | 2023 - 2024
      </a>
    </footer>
  );
};

export default Footer;
